import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { studentService } from '../Services/studentService';
import { setSnackError } from '../Reducers/snackErrors';
import { setSuccessSnack } from '../Reducers/snackSuccess';
import { handleApiError } from '../Utils/ApiErrorHandler';

export const useStudentGroups = () => {

  const [studentsGroups, setStudentsGroups] = useState([]);
  const [enableGroups, setEnableGroups] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const fetchStudentGroups = async (locationId, tutorId, semesterId) => {
    if (!locationId) return null;

    setLoading(true);
    setEnableGroups(prev => !prev);
    try {
      const data = await studentService.getStudentGroups(locationId, tutorId, semesterId);
      setStudentsGroups(data);
      return data;
    } catch (error) {
      handleApiError(error, dispatch, "get student groups")
      return null;
    } finally {
      setLoading(false);
    }
  };

  const deleteStudentGroup = async (id) => {
    try {
      setLoading(true);
      const data = await studentService.deleteStudentGroup(id);
      if (data.status === "Removed") {
        dispatch(setSuccessSnack({title: 'Success', body: 'Deleted student group'}))
        return true;
      }
      else{
        dispatch(setSnackError({title: 'Error', body: 'Unable to remove student group.'}))
        return false;
      }
      
    } catch (error) {
      handleApiError(error, dispatch, "delete student group")
      return false;
    }finally {
      setLoading(false);
    }
  }


  const createStudentGroup = async (payload) => {
    try {
      setLoading(true);
      const data = await studentService.createStudentGroup(payload);
      if (data.status === 'OK') {
        dispatch(setSuccessSnack({title:'Success', body: `Created student group ${data.id}`}));
        return true;
      }    
    } catch (error) {
      handleApiError(error, dispatch, "create student group")
      return false;
    }finally {
      setLoading(false);
    }
  }

  const updateStudentGroup = async (payload) => {
    try {
      setLoading(true);
      const data = await studentService.updateStudentGroup(payload);
      if (data.status === 'Updated') {
        dispatch(setSuccessSnack({title:'Success', body: `Updated student group ${data.id}`}));
        return true;
      }    
    } catch (error) {
      handleApiError(error, dispatch, "updating groups")
      return false;
    }finally {
      setLoading(false);
    }
  }

  const createStudentGroupAttendies = async (students, group_id) => {
    try {
      setLoading(true);
      const data = await studentService.createStudentGroupAttendies(students, group_id);
      if (data.status === 'OK') {
        dispatch(setSuccessSnack({title:'Success', body: `Updated student group ${data.id}`}));
        return true;
      }
      return false;
    } catch (error) {
      handleApiError(error, dispatch, "create student group")
      return false;
    }finally {
      setLoading(false);
    }
  }



  return { 
    studentsGroups, 
    enableGroups, 
    loading,
    fetchStudentGroups,
    deleteStudentGroup,
    createStudentGroup,
    updateStudentGroup,
    createStudentGroupAttendies
  };
};